/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaCittadinoScadenzaBandoDTO { 
    data_apertura?: string;
    data_chiusura?: string;
    data_graduatoria?: string;
}

